// posts#discuss — the community feed page is the React discuss app.
import { registerPage } from "../first"
import { mountDiscussApp } from "../discuss_app"

export const PostsDiscussPage = {
  onDomReady(): void {
    mountDiscussApp()
  },
}

registerPage("PostsDiscussPage", PostsDiscussPage)
